/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { Content as ContentType } from '@coursera-web/cml';
import { TranslateContentButton, TranslationContextProvider } from '@coursera-web/ondemand-translation';

import type { SectionName } from '@coursera/event-pulse-types';

import type { HTMLContent } from 'bundles/compound-assessments/types/FormParts';
import TranslatedContent from 'bundles/peer/components/translation/TranslatedContent';
import { TranslationFailedMessage } from 'bundles/peer/components/translation/TranslationFailedMessage';

type Props = {
  assumeStringIsHtml?: boolean;
  content?: ContentType | HTMLContent;
  contentId?: string;
  display?: 'inline-block' | 'block';
  className?: string;
  courseId?: string;
  eventingSectionName?: SectionName;
};

const styles = {
  translateButton: () => css`
    margin-top: 16px;
  `,
};

/**
 * This is a self-contained component that provides complete translation functionality for a single content.
 * It takes content as an input and renders it together with the translation button.
 */
const TranslatedContentWithButton = ({
  assumeStringIsHtml = false,
  courseId,
  eventingSectionName,
  ...otherProps
}: Props) => {
  return (
    <TranslationContextProvider>
      <div>
        <TranslatedContent enableTranslation={true} assumeStringIsHtml={assumeStringIsHtml} {...otherProps} />
      </div>
      <div>
        <TranslateContentButton
          cssOverride={styles.translateButton}
          courseId={courseId}
          eventingSectionName={eventingSectionName}
        />
      </div>
      <TranslationFailedMessage />
    </TranslationContextProvider>
  );
};

export default TranslatedContentWithButton;
